import { createContext } from 'react';
export const ChannelCapabilitiesConfigContext = /*#__PURE__*/createContext({
  capabilitiesBlob: null,
  originalGenericChannelId: null,
  genericChannelId: null
});